import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/useAuth";
import p from "./Pagina.module.css";

export default function Login() {
  const { user, loading, disponible, entrarConGoogle, entrarConCorreo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const destino = location.state?.desde || "/cuenta";

  if (loading) {
    return (
      <div className={`container ${p.centrado}`}>
        <p className="mono">Verificando sesion...</p>
      </div>
    );
  }

  if (user) return <Navigate to={destino} replace />;

  if (!disponible) {
    return (
      <div className={`container ${p.centrado}`}>
        <p className="eyebrow">Acceso</p>
        <h1>Autenticacion no configurada</h1>
        <p className={p.tarjetaTexto}>
          Esta web todavia no tiene Firebase conectado, asi que no hay inicio de
          sesion disponible. Copia <code>.env.example</code> a <code>.env</code>{" "}
          con las credenciales del proyecto y vuelve a levantar el servidor.
        </p>
      </div>
    );
  }

  async function conGoogle() {
    setError(null);
    try {
      await entrarConGoogle();
      navigate(destino, { replace: true });
    } catch (err) {
      setError(traducirError(err));
    }
  }

  async function conCorreo(e) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await entrarConCorreo(email, password);
      navigate(destino, { replace: true });
    } catch (err) {
      setError(traducirError(err));
      setEnviando(false);
    }
  }

  return (
    <div className={`container ${p.centrado}`}>
      <p className="eyebrow">Acceso</p>
      <h1>Iniciar sesion</h1>
      <p className={p.tarjetaTexto}>
        Entra para ver el estado de tus pedidos y tus cotizaciones anteriores.
      </p>

      <button type="button" className="btn btn--ghost btn--block" onClick={conGoogle}>
        Continuar con Google
      </button>

      <p className="hint" style={{ justifySelf: "center" }}>
        o con tu correo
      </p>

      <form
        onSubmit={conCorreo}
        style={{ display: "grid", gap: "0.75rem", width: "100%" }}
      >
        <div className="field">
          <label className="label" htmlFor="lg-email">
            Correo
          </label>
          <input
            id="lg-email"
            className="input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="field">
          <label className="label" htmlFor="lg-pass">
            Contrasena
          </label>
          <input
            id="lg-pass"
            className="input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {error && <p className={p.error}>{error}</p>}

        <button type="submit" className="btn btn--accent btn--block" disabled={enviando}>
          {enviando ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}

function traducirError(err) {
  const codigo = err?.code || "";
  if (codigo.includes("invalid-credential") || codigo.includes("wrong-password")) {
    return "Correo o contrasena incorrectos.";
  }
  if (codigo.includes("user-not-found")) {
    return "No existe una cuenta con ese correo.";
  }
  if (codigo.includes("too-many-requests")) {
    return "Demasiados intentos. Espera unos minutos e intenta de nuevo.";
  }
  if (codigo.includes("popup-closed-by-user")) {
    return "Se cerro la ventana de Google antes de terminar.";
  }
  return "No se pudo iniciar sesion. Intenta de nuevo.";
}
